// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * ProjectAttributes type.
 * @typedef {object} ProjectAttributes
 * @property {Date | null} createdAt - Attribute value.
 * @property {Date | null} deadlineAt - Attribute value.
 * @property {string} id - Attribute value.
 * @property {string | null} name - Attribute value.
 * @property {string | null} organizationId - Attribute value.
 * @property {number} pricePerHourCents - Attribute value.
 * @property {string} pricePerHourCurrency - Attribute value.
 * @property {number} pricePerHourTransportCents - Attribute value.
 * @property {string} pricePerHourTransportCurrency - Attribute value.
 * @property {string | null} repositoryFullName - Attribute value.
 * @property {string | null} repositoryHost - Attribute value.
 * @property {string | null} repositoryIdentitySource - Attribute value.
 * @property {Date | null} repositoryIdentityVerifiedAt - Attribute value.
 * @property {string | null} repositoryName - Attribute value.
 * @property {string | null} repositoryOwner - Attribute value.
 * @property {string | null} repositoryProvider - Attribute value.
 * @property {string | null} state - Attribute value.
 * @property {boolean} automationAssignable - Attribute value.
 * @property {boolean} automationEnabled - Attribute value.
 * @property {string | null} automationEnvironmentId - Attribute value.
 * @property {"complete" | "disabled" | "environment_required"} automationSetupStatus - Attribute value.
 * @property {string} translatedState - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by ProjectCreateAttributes.
 * @typedef {object} ProjectCreateAttributes
 * @property {Date | string | null} [deadlineAt] - Permitted deadlineAt value.
 * @property {ProjectAttributes["name"] | null} [name] - Permitted name value.
 * @property {ProjectAttributes["organizationId"] | null} [organizationId] - Permitted organizationId value.
 * @property {ProjectAttributes["pricePerHourCents"] | null} [pricePerHourCents] - Permitted pricePerHourCents value.
 * @property {ProjectAttributes["pricePerHourCurrency"] | null} [pricePerHourCurrency] - Permitted pricePerHourCurrency value.
 * @property {ProjectAttributes["pricePerHourTransportCents"] | null} [pricePerHourTransportCents] - Permitted pricePerHourTransportCents value.
 * @property {ProjectAttributes["pricePerHourTransportCurrency"] | null} [pricePerHourTransportCurrency] - Permitted pricePerHourTransportCurrency value.
 * @property {string | null | null} [repositoryFullName] - Permitted repositoryFullName value.
 * @property {ProjectAttributes["state"] | null} [state] - Permitted state value.
 * @property {boolean | null} [automationEnabled] - Permitted automationEnabled value.
 * @property {string | null | null} [automationEnvironmentId] - Permitted automationEnvironmentId value.
 */
/**
 * Attributes accepted by ProjectUpdateAttributes.
 * @typedef {object} ProjectUpdateAttributes
 * @property {Date | string | null} [deadlineAt] - Permitted deadlineAt value.
 * @property {ProjectAttributes["name"] | null} [name] - Permitted name value.
 * @property {ProjectAttributes["organizationId"] | null} [organizationId] - Permitted organizationId value.
 * @property {ProjectAttributes["pricePerHourCents"] | null} [pricePerHourCents] - Permitted pricePerHourCents value.
 * @property {ProjectAttributes["pricePerHourCurrency"] | null} [pricePerHourCurrency] - Permitted pricePerHourCurrency value.
 * @property {ProjectAttributes["pricePerHourTransportCents"] | null} [pricePerHourTransportCents] - Permitted pricePerHourTransportCents value.
 * @property {ProjectAttributes["pricePerHourTransportCurrency"] | null} [pricePerHourTransportCurrency] - Permitted pricePerHourTransportCurrency value.
 * @property {string | null | null} [repositoryFullName] - Permitted repositoryFullName value.
 * @property {ProjectAttributes["state"] | null} [state] - Permitted state value.
 * @property {boolean | null} [automationEnabled] - Permitted automationEnabled value.
 * @property {string | null | null} [automationEnvironmentId] - Permitted automationEnvironmentId value.
 */
/**
 * Frontend model for Project.
 * @augments {FrontendModelBase<ProjectAttributes, ProjectCreateAttributes, ProjectUpdateAttributes, ProjectAttributes["id"], string>}
 */
class Project extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "Project",
      attributes: [
        "createdAt",
        "deadlineAt",
        "id",
        "name",
        "organizationId",
        "pricePerHourCents",
        "pricePerHourCurrency",
        "pricePerHourTransportCents",
        "pricePerHourTransportCurrency",
        "repositoryFullName",
        "repositoryHost",
        "repositoryIdentitySource",
        "repositoryIdentityVerifiedAt",
        "repositoryName",
        "repositoryOwner",
        "repositoryProvider",
        "state",
        "automationAssignable",
        "automationEnabled",
        "automationEnvironmentId",
        "automationSetupStatus",
        "translatedState",
        "updatedAt",
      ],
      memberCommands: [
        "verifyRepositoryIdentity",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      boards: {type: "hasMany"},
      organization: {type: "belongsTo"},
      projectAutoassignedUsers: {type: "hasMany"},
      taskTypes: {type: "hasMany"},
      userProjectLinks: {type: "hasMany"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      boards: "Board",
      organization: "Organization",
      projectAutoassignedUsers: "ProjectAutoassignedUser",
      taskTypes: "TaskType",
      userProjectLinks: "UserProjectLink",
    }
  }

  /** @returns {ProjectAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {ProjectAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {ProjectAttributes["deadlineAt"]} - Attribute value. */
  deadlineAt() { return /** @type {ProjectAttributes["deadlineAt"]} */ (this.readAttribute("deadlineAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setDeadlineAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("deadlineAt", newValue)) }

  /** @returns {ProjectAttributes["id"]} - Attribute value. */
  id() { return /** @type {ProjectAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {ProjectAttributes["id"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {ProjectAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {ProjectAttributes["name"]} - Attribute value. */
  name() { return /** @type {ProjectAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {ProjectAttributes["name"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {ProjectAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {ProjectAttributes["organizationId"]} - Attribute value. */
  organizationId() { return /** @type {ProjectAttributes["organizationId"]} */ (this.readAttribute("organizationId")) }

  /**
   * @param {ProjectAttributes["organizationId"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["organizationId"] | null} - Assigned value.
   */
  setOrganizationId(newValue) { return /** @type {ProjectAttributes["organizationId"] | null} */ (this.setAttribute("organizationId", newValue)) }

  /** @returns {ProjectAttributes["pricePerHourCents"]} - Attribute value. */
  pricePerHourCents() { return /** @type {ProjectAttributes["pricePerHourCents"]} */ (this.readAttribute("pricePerHourCents")) }

  /**
   * @param {ProjectAttributes["pricePerHourCents"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["pricePerHourCents"] | null} - Assigned value.
   */
  setPricePerHourCents(newValue) { return /** @type {ProjectAttributes["pricePerHourCents"] | null} */ (this.setAttribute("pricePerHourCents", newValue)) }

  /** @returns {ProjectAttributes["pricePerHourCurrency"]} - Attribute value. */
  pricePerHourCurrency() { return /** @type {ProjectAttributes["pricePerHourCurrency"]} */ (this.readAttribute("pricePerHourCurrency")) }

  /**
   * @param {ProjectAttributes["pricePerHourCurrency"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["pricePerHourCurrency"] | null} - Assigned value.
   */
  setPricePerHourCurrency(newValue) { return /** @type {ProjectAttributes["pricePerHourCurrency"] | null} */ (this.setAttribute("pricePerHourCurrency", newValue)) }

  /** @returns {ProjectAttributes["pricePerHourTransportCents"]} - Attribute value. */
  pricePerHourTransportCents() { return /** @type {ProjectAttributes["pricePerHourTransportCents"]} */ (this.readAttribute("pricePerHourTransportCents")) }

  /**
   * @param {ProjectAttributes["pricePerHourTransportCents"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["pricePerHourTransportCents"] | null} - Assigned value.
   */
  setPricePerHourTransportCents(newValue) { return /** @type {ProjectAttributes["pricePerHourTransportCents"] | null} */ (this.setAttribute("pricePerHourTransportCents", newValue)) }

  /** @returns {ProjectAttributes["pricePerHourTransportCurrency"]} - Attribute value. */
  pricePerHourTransportCurrency() { return /** @type {ProjectAttributes["pricePerHourTransportCurrency"]} */ (this.readAttribute("pricePerHourTransportCurrency")) }

  /**
   * @param {ProjectAttributes["pricePerHourTransportCurrency"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["pricePerHourTransportCurrency"] | null} - Assigned value.
   */
  setPricePerHourTransportCurrency(newValue) { return /** @type {ProjectAttributes["pricePerHourTransportCurrency"] | null} */ (this.setAttribute("pricePerHourTransportCurrency", newValue)) }

  /** @returns {ProjectAttributes["repositoryFullName"]} - Attribute value. */
  repositoryFullName() { return /** @type {ProjectAttributes["repositoryFullName"]} */ (this.readAttribute("repositoryFullName")) }

  /**
   * @param {string | null | null} newValue - New attribute value.
   * @returns {string | null | null} - Assigned value.
   */
  setRepositoryFullName(newValue) { return /** @type {string | null | null} */ (this.setAttribute("repositoryFullName", newValue)) }

  /** @returns {ProjectAttributes["repositoryHost"]} - Attribute value. */
  repositoryHost() { return /** @type {ProjectAttributes["repositoryHost"]} */ (this.readAttribute("repositoryHost")) }

  /**
   * @param {ProjectAttributes["repositoryHost"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["repositoryHost"] | null} - Assigned value.
   */
  setRepositoryHost(newValue) { return /** @type {ProjectAttributes["repositoryHost"] | null} */ (this.setAttribute("repositoryHost", newValue)) }

  /** @returns {ProjectAttributes["repositoryIdentitySource"]} - Attribute value. */
  repositoryIdentitySource() { return /** @type {ProjectAttributes["repositoryIdentitySource"]} */ (this.readAttribute("repositoryIdentitySource")) }

  /**
   * @param {ProjectAttributes["repositoryIdentitySource"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["repositoryIdentitySource"] | null} - Assigned value.
   */
  setRepositoryIdentitySource(newValue) { return /** @type {ProjectAttributes["repositoryIdentitySource"] | null} */ (this.setAttribute("repositoryIdentitySource", newValue)) }

  /** @returns {ProjectAttributes["repositoryIdentityVerifiedAt"]} - Attribute value. */
  repositoryIdentityVerifiedAt() { return /** @type {ProjectAttributes["repositoryIdentityVerifiedAt"]} */ (this.readAttribute("repositoryIdentityVerifiedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setRepositoryIdentityVerifiedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("repositoryIdentityVerifiedAt", newValue)) }

  /** @returns {ProjectAttributes["repositoryName"]} - Attribute value. */
  repositoryName() { return /** @type {ProjectAttributes["repositoryName"]} */ (this.readAttribute("repositoryName")) }

  /**
   * @param {ProjectAttributes["repositoryName"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["repositoryName"] | null} - Assigned value.
   */
  setRepositoryName(newValue) { return /** @type {ProjectAttributes["repositoryName"] | null} */ (this.setAttribute("repositoryName", newValue)) }

  /** @returns {ProjectAttributes["repositoryOwner"]} - Attribute value. */
  repositoryOwner() { return /** @type {ProjectAttributes["repositoryOwner"]} */ (this.readAttribute("repositoryOwner")) }

  /**
   * @param {ProjectAttributes["repositoryOwner"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["repositoryOwner"] | null} - Assigned value.
   */
  setRepositoryOwner(newValue) { return /** @type {ProjectAttributes["repositoryOwner"] | null} */ (this.setAttribute("repositoryOwner", newValue)) }

  /** @returns {ProjectAttributes["repositoryProvider"]} - Attribute value. */
  repositoryProvider() { return /** @type {ProjectAttributes["repositoryProvider"]} */ (this.readAttribute("repositoryProvider")) }

  /**
   * @param {ProjectAttributes["repositoryProvider"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["repositoryProvider"] | null} - Assigned value.
   */
  setRepositoryProvider(newValue) { return /** @type {ProjectAttributes["repositoryProvider"] | null} */ (this.setAttribute("repositoryProvider", newValue)) }

  /** @returns {ProjectAttributes["state"]} - Attribute value. */
  state() { return /** @type {ProjectAttributes["state"]} */ (this.readAttribute("state")) }

  /**
   * @param {ProjectAttributes["state"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["state"] | null} - Assigned value.
   */
  setState(newValue) { return /** @type {ProjectAttributes["state"] | null} */ (this.setAttribute("state", newValue)) }

  /** @returns {ProjectAttributes["automationAssignable"]} - Attribute value. */
  automationAssignable() { return /** @type {ProjectAttributes["automationAssignable"]} */ (this.readAttribute("automationAssignable")) }

  /**
   * @param {ProjectAttributes["automationAssignable"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["automationAssignable"] | null} - Assigned value.
   */
  setAutomationAssignable(newValue) { return /** @type {ProjectAttributes["automationAssignable"] | null} */ (this.setAttribute("automationAssignable", newValue)) }

  /** @returns {ProjectAttributes["automationEnabled"]} - Attribute value. */
  automationEnabled() { return /** @type {ProjectAttributes["automationEnabled"]} */ (this.readAttribute("automationEnabled")) }

  /**
   * @param {boolean | null} newValue - New attribute value.
   * @returns {boolean | null} - Assigned value.
   */
  setAutomationEnabled(newValue) { return /** @type {boolean | null} */ (this.setAttribute("automationEnabled", newValue)) }

  /** @returns {ProjectAttributes["automationEnvironmentId"]} - Attribute value. */
  automationEnvironmentId() { return /** @type {ProjectAttributes["automationEnvironmentId"]} */ (this.readAttribute("automationEnvironmentId")) }

  /**
   * @param {string | null | null} newValue - New attribute value.
   * @returns {string | null | null} - Assigned value.
   */
  setAutomationEnvironmentId(newValue) { return /** @type {string | null | null} */ (this.setAttribute("automationEnvironmentId", newValue)) }

  /** @returns {ProjectAttributes["automationSetupStatus"]} - Attribute value. */
  automationSetupStatus() { return /** @type {ProjectAttributes["automationSetupStatus"]} */ (this.readAttribute("automationSetupStatus")) }

  /**
   * @param {ProjectAttributes["automationSetupStatus"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["automationSetupStatus"] | null} - Assigned value.
   */
  setAutomationSetupStatus(newValue) { return /** @type {ProjectAttributes["automationSetupStatus"] | null} */ (this.setAttribute("automationSetupStatus", newValue)) }

  /** @returns {ProjectAttributes["translatedState"]} - Attribute value. */
  translatedState() { return /** @type {ProjectAttributes["translatedState"]} */ (this.readAttribute("translatedState")) }

  /**
   * @param {ProjectAttributes["translatedState"] | null} newValue - New attribute value.
   * @returns {ProjectAttributes["translatedState"] | null} - Assigned value.
   */
  setTranslatedState(newValue) { return /** @type {ProjectAttributes["translatedState"] | null} */ (this.setAttribute("translatedState", newValue)) }

  /** @returns {ProjectAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {ProjectAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Runs verifyRepositoryIdentity.
   * @param {{repositoryFullName?: string}} [args] - Command argument.
   * @returns {Promise<{project: any, status: string}>} - Command response.
   */
  async verifyRepositoryIdentity(args = {}) {
    return /** @type {{project: any, status: string}} */ (await Project.executeCustomCommand({
      commandName: "verify-repository-identity",
      commandType: "verify-repository-identity",
      memberId: this.scalarPrimaryKeyValue("Custom member command Project#verifyRepositoryIdentity"),
      payload: Project.normalizeCustomCommandPayloadArguments([args]),
      resourcePath: Project.resourcePath()
    }))
  }

  /**
   * Returns boards relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./board.js").Board, import("./board.js").BoardCreateAttributes>} - Relationship helper.
   */
  boardsRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./board.js").Board, import("./board.js").BoardCreateAttributes>} */ (this.getRelationshipByName("boards")) }

  /**
   * Returns boards.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./board.js").Board, import("./board.js").BoardCreateAttributes>} - Relationship helper.
   */
  boards() { return this.boardsRelationship() }

  /**
   * Returns loaded boards.
   * @returns {Array<import("./board.js").Board>} - Loaded related models.
   */
  boardsLoaded() { return this.boardsRelationship().loaded() }

  /**
   * Loads boards.
   * @returns {Promise<Array<import("./board.js").Board>>} - Loaded related models.
   */
  async loadBoards() { return await this.boardsRelationship().load() }

  /**
   * Returns organization relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Project, import("./organization.js").Organization, import("./organization.js").OrganizationCreateAttributes>} - Relationship helper.
   */
  organizationRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Project, import("./organization.js").Organization, import("./organization.js").OrganizationCreateAttributes>} */ (this.getRelationshipByName("organization")) }

  /**
   * Returns organization.
   * @returns {import("./organization.js").Organization | null} - Loaded related model.
   */
  organization() { return this.organizationRelationship().loaded() }

  /**
   * Builds organization.
   * @param {import("./organization.js").OrganizationCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./organization.js").Organization} - Built related model.
   */
  buildOrganization(attributes = {}) { return this.organizationRelationship().build(attributes) }

  /**
   * Loads organization.
   * @returns {Promise<import("./organization.js").Organization | null>} - Loaded related model.
   */
  async loadOrganization() { return await this.organizationRelationship().load() }

  /**
   * Returns or loads organization.
   * @returns {Promise<import("./organization.js").Organization | null>} - Loaded related model.
   */
  async organizationOrLoad() { return await this.organizationRelationship().orLoad() }

  /**
   * Sets organization.
   * @param {import("./organization.js").Organization | null} model - Related model.
   * @returns {void}
   */
  setOrganization(model) { this.organizationRelationship().setLoaded(model) }

  /**
   * Returns projectAutoassignedUsers relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./project-autoassigned-user.js").ProjectAutoassignedUser, import("./project-autoassigned-user.js").ProjectAutoassignedUserCreateAttributes>} - Relationship helper.
   */
  projectAutoassignedUsersRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./project-autoassigned-user.js").ProjectAutoassignedUser, import("./project-autoassigned-user.js").ProjectAutoassignedUserCreateAttributes>} */ (this.getRelationshipByName("projectAutoassignedUsers")) }

  /**
   * Returns projectAutoassignedUsers.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./project-autoassigned-user.js").ProjectAutoassignedUser, import("./project-autoassigned-user.js").ProjectAutoassignedUserCreateAttributes>} - Relationship helper.
   */
  projectAutoassignedUsers() { return this.projectAutoassignedUsersRelationship() }

  /**
   * Returns loaded projectAutoassignedUsers.
   * @returns {Array<import("./project-autoassigned-user.js").ProjectAutoassignedUser>} - Loaded related models.
   */
  projectAutoassignedUsersLoaded() { return this.projectAutoassignedUsersRelationship().loaded() }

  /**
   * Loads projectAutoassignedUsers.
   * @returns {Promise<Array<import("./project-autoassigned-user.js").ProjectAutoassignedUser>>} - Loaded related models.
   */
  async loadProjectAutoassignedUsers() { return await this.projectAutoassignedUsersRelationship().load() }

  /**
   * Returns taskTypes relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./task-type.js").TaskType, import("./task-type.js").TaskTypeCreateAttributes>} - Relationship helper.
   */
  taskTypesRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./task-type.js").TaskType, import("./task-type.js").TaskTypeCreateAttributes>} */ (this.getRelationshipByName("taskTypes")) }

  /**
   * Returns taskTypes.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./task-type.js").TaskType, import("./task-type.js").TaskTypeCreateAttributes>} - Relationship helper.
   */
  taskTypes() { return this.taskTypesRelationship() }

  /**
   * Returns loaded taskTypes.
   * @returns {Array<import("./task-type.js").TaskType>} - Loaded related models.
   */
  taskTypesLoaded() { return this.taskTypesRelationship().loaded() }

  /**
   * Loads taskTypes.
   * @returns {Promise<Array<import("./task-type.js").TaskType>>} - Loaded related models.
   */
  async loadTaskTypes() { return await this.taskTypesRelationship().load() }

  /**
   * Returns userProjectLinks relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./user-project-link.js").UserProjectLink, import("./user-project-link.js").UserProjectLinkCreateAttributes>} - Relationship helper.
   */
  userProjectLinksRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./user-project-link.js").UserProjectLink, import("./user-project-link.js").UserProjectLinkCreateAttributes>} */ (this.getRelationshipByName("userProjectLinks")) }

  /**
   * Returns userProjectLinks.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Project, import("./user-project-link.js").UserProjectLink, import("./user-project-link.js").UserProjectLinkCreateAttributes>} - Relationship helper.
   */
  userProjectLinks() { return this.userProjectLinksRelationship() }

  /**
   * Returns loaded userProjectLinks.
   * @returns {Array<import("./user-project-link.js").UserProjectLink>} - Loaded related models.
   */
  userProjectLinksLoaded() { return this.userProjectLinksRelationship().loaded() }

  /**
   * Loads userProjectLinks.
   * @returns {Promise<Array<import("./user-project-link.js").UserProjectLink>>} - Loaded related models.
   */
  async loadUserProjectLinks() { return await this.userProjectLinksRelationship().load() }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(Project)

export {Project}

export default Project
